var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 12.9064C24.0002 12.0556 23.9223 11.2375 23.7776 10.4521H12.2451V15.0935H18.8351C18.5512 16.5933 17.6885 17.8641 16.3917 18.7149V21.7255H20.349C22.6644 19.6366 24.0002 16.5606 24.0002 12.9064Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2452 24.6398C15.5513 24.6398 18.3231 23.5654 20.3491 21.7329L16.3918 18.7223C15.2953 19.4422 13.8927 19.8676 12.2452 19.8676C9.05598 19.8676 6.35654 17.757 5.39364 14.9209H1.30273V18.0297C3.31758 21.951 7.45858 24.6398 12.2452 24.6398Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39332 14.9173C5.14842 14.1974 5.00928 13.4284 5.00928 12.6375C5.00928 11.8467 5.14842 11.0777 5.39332 10.3578V7.24902H1.30241C0.473098 8.86885 0 10.7014 0 12.6375C0 14.5737 0.473098 16.4062 1.30241 18.026L5.39332 14.9173Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2452 5.41186C14.043 5.41186 15.6571 6.01725 16.9261 7.20621L20.4382 3.76476C18.3176 1.82861 15.5458 0.639648 12.2452 0.639648C7.45858 0.639648 3.31758 3.32845 1.30273 7.24984L5.39364 10.3586C6.35654 7.52254 9.05598 5.41186 12.2452 5.41186Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.c6787b5d39af52ad41049025112c2070.svg";
export { ForwardRef as ReactComponent };